import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch} from 'react-router-dom';
import Router from 'react-router';

/*
* Authentication
*/
import Alt from 'alt';
import history from './history';
import axios from 'axios';
import AuthActions from './actions/AuthActions';
import AuthStore from './stores/AuthStore';
import routes from './routes';

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

// Containers
import Full from './containers/Full/'

// Views
import Login from './views/Pages/Login/'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

import Logout from './components/Logout/'

function requireAuth() {
  if (AuthStore.getState().accessToken === null || AuthStore.getState().user === null  || AuthStore.getState().user == undefined || AuthStore.getState().user.entity_id == null) {
    history.replace("/login");
  }
}

// Try to connect user from local storage value
requireAuth();
AuthActions.localLogin();


ReactDOM.render((
  <HashRouter>
    <Switch>
      <Route exact path="/login" name="Login Page" component={Login}/>
      <Route exact path="/logout" name="Logout Page" component={Logout}/>
      <Route exact path="/404" name="Page 404" component={Page404}/>
      <Route exact path="/500" name="Page 500" component={Page500}/>
      <Route path="/" name="Home" component={Full}/>
    </Switch>
  </HashRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js